export const baseUrl = '/api/learning_path';
